import React from 'react';
import { Card } from "react-bootstrap";
import face_laszlo_csato from "../../assets/img/3.png";
import ShowMoreText from "react-show-more-text";
import proj_alternative_uefa from "../../assets/img/proj_alternative_uefa.png";

const Laszlo_Csato_alternative_UEFA = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_alternative_uefa} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_laszlo_csato}
              /* this will be the text on the banner */
              alt="Alternative UEFA association rankings"
            />{" "}
            <p className="text7">László Csató</p>
            <br />
            <p className="text8">
              Research Fellow{" "}
            </p>
            <p className="text8">Research Group of Operations Research and Decision Systems, SZTAKI </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            UEFA association ranking determines the association’s position in the access list, which in
            turn determines the stage at which each club enters UEFA club competitions. Association
            coefficient is the average of the points collected by all clubs of the association in the last five
            seasons. However, its calculation suffers from serious weaknesses such as giving arbitrary
            bonus points, ignoring the opponent of the team, and misaligned consideration of two-legged
            matches. This project aims to propose alternative rankings following an Elo-inspired
            approach. Extensive sensitivity analyses will also be conducted to assess the robustness of the
            rankings.

            <br />
            <br />
            Related literature:{" "}

            <ul>
                <li>
                Ausloos, M., Cloots, R., Gadomski, A., &amp; Vitanov, N. K. (2014). Ranking structures 
                and rank–rank correlations of countries: The FIFA and UEFA cases. International Journal 
                of Modern Physics C, 25(11), 1450060.
                </li>
                <li>
                Csató, L. (2022). UEFA against the champions? An evaluation of the recent reform of the 
                Champions League qualification. Journal of Sports Economics, 23(8), 991-1016.

                </li>
                <li>
                Csató, L. (2024). Club coefficients in the UEFA Champions League: Time for shift to an 
                Elo-based formula. International Journal of Performance Analysis in Sport, 24(2), 119-134.
                </li>
                <li>
                    <a href="https://www.uefa.com/nationalassociations/uefarankings/country/about/">Learn about UEFA rankings</a>
                </li>
            </ul>

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Laszlo_Csato_alternative_UEFA;